import { useEffect, useState } from "react"
import { dictionaryCRUD } from "../../../actions/dictionary"
import { selector } from "../../../api"
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { toast } from "react-toastify"
import { useParams, useNavigate } from "react-router-dom";


const dictionaryItemSchema = Yup.object().shape({
  dictionary_item_code: Yup.string(),
  dictionary_item_name_en: Yup.string().required('English name is required'),
  dictionary_item_name_sw: Yup.string().required('Swahili name is required'),
  dictionary_item_parent: Yup.string(),
  dictionary: Yup.string().required('Dictionary is required'),
})


const initialValues = {
  dictionary_item_code: '',
  dictionary_item_name_en: '',
  dictionary_item_name_sw: '',
  dictionary_item_parent: '',
  dictionary: '',
}

export const EditDictionaryItem = () => {
  const user = selector.User()
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [dictionary, setDictionary] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)

  const navigate = useNavigate();
  const param = useParams();
  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      dictionaryCRUD.loadAllDictionary().then((resp) => {
        setDictionary(resp.data)
      }).finally(() => { })
      dictionaryCRUD.loadDictionaryItemById(param.id).then((resp) => {
        formik.setFieldValue("dictionary_item_code", resp.data ? resp.data.dictionary_item_code : '');
        formik.setFieldValue("dictionary_item_name_en", resp.data ? resp.data.dictionary_item_name_en : '');
        formik.setFieldValue("dictionary_item_name_sw", resp.data ? resp.data.dictionary_item_name_sw : '');
        formik.setFieldValue("dictionary_item_parent", resp.data ? resp.data.dictionary_item_parent : '');
        formik.setFieldValue("dictionary", resp.data ? resp.data.dictionary : '');
        setDataLoaded(true)
      }).finally(() => {
        setLoading(false)
      })
    }, 1000)

  }, [])
  const formik = useFormik({
    initialValues,
    validationSchema: dictionaryItemSchema,
    onSubmit: (values) => {
      const { dictionary_item_code, dictionary_item_name_en, dictionary_item_name_sw, dictionary_item_parent, dictionary } = values
      const recorded_by = user.id
      const data = { dictionary_item_code, dictionary_item_name_en, dictionary_item_name_sw, dictionary_item_parent, dictionary, recorded_by }
      setSaving(true)
      dictionaryCRUD.saveDictionaryItemChanges(param.id, data).then(() => {
        toast.success('Dictionary item changes has been saved.', { autoClose: 5000 })
        navigate('/dictionary-item')
      }).catch((error) => {
        toast.error('Failed to save changes', { autoClose: 5000 })
      }).finally(() => {
        setSaving(false)
      })
    }
  })

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            {/* Page Title */}
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Edit Dictionary Item</h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><a href="/dictionary-item">Dictionary Items</a></li>
                      <li className="breadcrumb-item active">Edit</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            {/* Loading Spinner */}
            {loading && (
              <div className="row">
                <div className="col-12 text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2 text-muted">Loading data...</p>
                </div>
              </div>
            )}

            {/* Form Card */}
            {!loading && (
              <div className="row">
                <div className="col-lg-8 col-md-10 mx-auto">
                  <form onSubmit={formik.handleSubmit}>
                    <div className="card shadow-sm">
                      <div className="card-header bg-primary bg-gradient">
                        <h5 className="card-title mb-0 text-white">
                          <i className="ri-edit-line me-2"></i>
                          Edit Dictionary Item
                        </h5>
                      </div>
                      <div className="card-body p-4">
                        {/* English Name */}
                        <div className="mb-4">
                          <label className="form-label fw-semibold">
                            English Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control form-control-lg ${formik.touched.dictionary_item_name_en && formik.errors.dictionary_item_name_en ? 'is-invalid' : ''}`}
                            {...formik.getFieldProps('dictionary_item_name_en')}
                            placeholder="Enter English name"
                          />
                          {formik.touched.dictionary_item_name_en && formik.errors.dictionary_item_name_en && (
                            <div className="invalid-feedback">
                              {formik.errors.dictionary_item_name_en}
                            </div>
                          )}
                        </div>

                        {/* Swahili Name */}
                        <div className="mb-4">
                          <label className="form-label fw-semibold">
                            Swahili Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control form-control-lg ${formik.touched.dictionary_item_name_sw && formik.errors.dictionary_item_name_sw ? 'is-invalid' : ''}`}
                            {...formik.getFieldProps('dictionary_item_name_sw')}
                            placeholder="Enter Swahili name"
                          />
                          {formik.touched.dictionary_item_name_sw && formik.errors.dictionary_item_name_sw && (
                            <div className="invalid-feedback">
                              {formik.errors.dictionary_item_name_sw}
                            </div>
                          )}
                        </div>

                        {/* Dictionary Select */}
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Dictionary <span className="text-danger">*</span>
                          </label>
                          <select
                            className={`form-select form-select-lg ${formik.touched.dictionary && formik.errors.dictionary ? 'is-invalid' : ''}`}
                            {...formik.getFieldProps('dictionary')}
                          >
                            <option value="">-- Select Dictionary --</option>
                            {dictionary?.map((dt) => (
                              <option key={dt.id} value={dt.id}>{dt.dictionary_name_en || 'N/A'}</option>
                            ))}
                          </select>
                          {formik.touched.dictionary && formik.errors.dictionary && (
                            <div className="invalid-feedback">
                              {formik.errors.dictionary}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Card Footer with Buttons */}
                      <div className="card-footer bg-light d-flex justify-content-between align-items-center py-3">
                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-lg"
                          onClick={() => navigate('/dictionary-item')}
                        >
                          <i className="ri-arrow-left-line me-1"></i> Back
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg px-5"
                          disabled={saving || !dataLoaded}
                        >
                          {saving ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Saving...
                            </>
                          ) : (
                            <>
                              <i className="ri-save-line me-1"></i> Save Changes
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )

}